import React, { useState } from 'react'

import {Swiper, SwiperSlide} from 'swiper/react'
import {Navigation, Pagination} from 'swiper'
import 'swiper/css/pagination'
import 'swiper/css/grid'
import people1 from '../../../../images/mirea/people_1.png'
import people2 from '../../../../images/mirea/people_2.png'
import people3 from '../../../../images/mirea/people_3.png'
import '../../main/personalGenerium/personal.css'

import styles from './styles.module.scss'
import people4 from "../../../../images/main/people_4.png";
import people5 from "../../../../images/main/people_5.png";
import Balancer from "react-wrap-balancer";

const StudentsAboutMirea = () => {
  const [swiper, setSwiper] = useState(null);
  const [indexSwiperElem, setIndexSwiperElem] = useState(0)

  return (
    <div className={styles.wrapper}>
      <div className={styles.wr1}>
        <div className={styles.left}>
          <div>
            <p className={styles.title}>Что говорят студенты о программе?</p>
          </div>
        </div>
        <div className={styles.right}>
          <div className='flex flex-col'>
            <p className={styles.title}>Студенты о Generium</p>
          </div>
        </div>
      </div>
      <div className={styles.wr2}>
        <div className={styles.left}>
          <div className={styles.preview_people}>
            {indexSwiperElem !== 0 ? (
              <>
                <div onClick={() => swiper.slideTo(0)}>
                  <img className='preview_people-slider-photo' src={people1} alt='people' draggable='false'/>
                </div>
              </>
            ) : ''}
            {indexSwiperElem !== 1 ? (
              <>
                <div onClick={() => swiper.slideTo(1)}>
                  <img className='preview_people-slider-photo' src={people2} alt='people' draggable='false'/>
                </div>
              </>
            ) : ''}
            {indexSwiperElem !== 2 ? (
              <>
                <div onClick={() => swiper.slideTo(2)}>
                  <img className='preview_people-slider-photo' src={people3} alt='people' draggable='false'/>
                </div>
              </>
            ) : ''}

          </div>
          <div className={styles.preview_people_active}>
            {indexSwiperElem == 0 ? (
              <><img className='preview_people_active-slider-photo' src={people1} alt='people' draggable='false'/></>
            ) : ''}
            {indexSwiperElem == 1 ? (
              <><img className='preview_people_active-slider-photo' src={people2} alt='people' draggable='false'/></>
            ) : ''}
            {indexSwiperElem == 2 ? (
              <><img className='preview_people_active-slider-photo' src={people3} alt='people' draggable='false'/></>
            ) : ''}
          </div>
        </div>
        <div className={styles.right}>
          <p className={styles.text2}>
            {indexSwiperElem === 0
              ? 'Я решила пойти на Mabstudy, потому что увидела в компании Generium большой потенциал для собственного развития. Здесь мне нравится всё: отличные наставники, интересные задачи, возможность практики на современном производстве.'
              + '\n\n' +
              'Эта программа подойдет тем, кто хочет развиваться и построить карьеру в области биотехнологии. Ведь по завершении программы есть шанс остаться в команде Generium и продолжить осваивать новое дальше!'
              : indexSwiperElem === 1
                ? 'Программа Mabstudy стала важным этапом в моей жизни. В процессе обучения по программе я получил полезные знания и, что еще важнее, практические навыки и реальный опыт.'
                + '\n\n' +
                'Особенно ценной мне показалась возможность оказаться в рабочей обстановке. Обучиться работе на аппарате может каждый, но вот опыт взаимодействия с коллегами и понимание логистики отдела из книжек не получишь.'
                + '\n\n' +
                'Я нацелен на дальнейшую работу в Generium, поэтому уже сейчас стараюсь максимально вливаться в команду и перенимать как можно больше опыта от своего руководителя.'
                : indexSwiperElem === 2
                  ? 'В рамках Mabstudy огромное внимание уделяется обратной связи. Было очень приятно общаться с научными руководителями от Generium и получать от них дельные советы.'
                  + '\n\n' +
                  'Большим плюсом является и то, что лаборатория Mabstudy находится прямо на территории РТУ МИРЭА. Это позволяет комфортно совмещать учебу с написанием диплома. Я рада, что получила хороший опыт как во время работы в лаборатории, так и в ходе стажировки в компании. После окончания программы планирую устроиться в R&D-центр, в лабораторию хроматографических методов, и стать полезным специалистом.'
                  + '\n\n' +
                  'По моему мнению, программа подойдет студентам, которые заинтересованы в трудоемкой научной работе и готовы потратить свое время на написание качественного диплома.'
                  : null}
          </p>
          <div className="slider_main_mod_pg">
            <Swiper
              spaceBetween={70}
              slidesPerView={1}
              navigation
              onSlideChange={swiper => setIndexSwiperElem(swiper.activeIndex)}
              pagination={{
                type: 'fraction'
              }}
              onSwiper={setSwiper}
              modules={[Pagination, Navigation]}
              breakpoints={{
                640: {
                  slidesPerView: 1,
                  initialSlide: 0
                },
                480: {
                  spaceBetween: 16,
                  initialSlide: 0,
                  slideToClickedSlide: true
                },
                370: {
                  spaceBetween: 16,
                  initialSlide: 0,
                  slideToClickedSlide: true
                },
                320: {
                  spaceBetween: 16,
                  initialSlide: 0,
                  slideToClickedSlide: true
                }
              }}
            >
              <SwiperSlide id='0' className='wrapper-item-slider-people'>
                <div>
                  <div className={styles.img}>
                    <img className='people-slider-photo' src={people1} alt='people' draggable='false'/>
                  </div>
                  <div className={styles.desc}>
                    <p className={styles.text}>Я решила пойти на Mabstudy, потому что увидела в компании Generium большой потенциал для собственного развития. Здесь мне нравится всё: отличные наставники, интересные задачи, возможность практики на современном производстве.</p>
                    <p className={styles.text}>Эта программа подойдет тем, кто хочет развиваться и построить карьеру в области биотехнологии. Ведь по завершении программы есть шанс остаться в команде Generium и продолжить осваивать новое дальше!</p>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide id='1' className='wrapper-item-slider-people'>
                <div>
                  <div className={styles.img}>
                    <img className='people-slider-photo' src={people2} alt='people' draggable='false'/>
                  </div>
                  <div className={styles.desc}>
                    <p className={styles.text}>Программа Mabstudy стала важным этапом в моей жизни. В процессе обучения по программе я получил полезные знания и, что еще важнее, практические навыки и реальный опыт.</p>
                    <p className={styles.text}>Особенно ценной мне показалась возможность оказаться в рабочей обстановке. Обучиться работе на аппарате может каждый, но вот опыт взаимодействия с коллегами и понимание логистики отдела из книжек не получишь.</p>
                    <p className={styles.text}>Я нацелен на дальнейшую работу в Generium, поэтому уже сейчас стараюсь максимально вливаться в команду и перенимать как можно больше опыта от своего руководителя.</p>
                  </div>
                </div>
              </SwiperSlide>

              <SwiperSlide id='2' className='wrapper-item-slider-people'>
                <div>
                  <div className={styles.img}>
                    <img className='people-slider-photo' src={people3} alt='people' draggable='false'/>
                  </div>
                  <div className={styles.desc}>
                    <p className={styles.text}>В рамках Mabstudy огромное внимание уделяется обратной связи. Было очень приятно общаться с научными руководителями от Generium и получать от них дельные советы.</p>
                    <p className={styles.text}>Большим плюсом является и то, что лаборатория Mabstudy находится прямо на территории РТУ МИРЭА. Это позволяет комфортно совмещать учебу с написанием диплома. Я рада, что получила хороший опыт как во время работы в лаборатории, так и в ходе стажировки в компании. После окончания программы планирую устроиться в R&D-центр, в лабораторию хроматографических методов, и стать полезным специалистом.</p>
                    <p className={styles.text}>По моему мнению, программа подойдет студентам, которые заинтересованы в трудоемкой научной работе и готовы потратить свое время на написание качественного диплома.</p>
                  </div>
                </div>
              </SwiperSlide>
            </Swiper>
          </div>
          <p className={styles.text_b}>
            {indexSwiperElem === 0 ? (
              <>
                <p>Дарья, РТУ МИРЭА</p>
              </>
            ) : indexSwiperElem === 1 ? (
              <>
                <p>Иван, РТУ МИРЭА</p>
              </>
            ) : indexSwiperElem === 2 ? (
              <>
                <p>Екатерина, РТУ МИРЭА</p>
              </>
            ) : (
              <>
                <p>Дарья, РТУ МИРЭА</p>
              </>
            )}
          </p>
        </div>
      </div>
    </div>
  )
}

export default StudentsAboutMirea
